import { isNextAgreementSigner } from '@/shared/services/agreement-signing';

const AGREEMENT_STATUS_LABELS = {
  Drafted: 'Not sent',
  Sent: 'Sent',
  Partial: 'Partially signed',
  Signed: 'Signed',
  Accepted: 'Signed and accepted',
};

export function isAgreementWorkflowTask(task) {
  const templateType = task.workflow_artifact_template?.artifact_type;
  const artifactType = task.workflow_artifact?.artifact_type;

  return templateType === 'Agreement' || artifactType === 'Agreement';
}

export function agreementWorkflowTaskStatus(task, memberId) {
  const agreement = task.workflow_artifact?.agreement;

  if (!agreement) {
    if (task.workflow_artifact_template?.artifact_type === 'Agreement') {
      return 'Not created';
    }

    return null;
  }

  if (isNextAgreementSigner(agreement, memberId)) {
    return 'Ready to sign';
  }

  return AGREEMENT_STATUS_LABELS[agreement.status] ?? agreement.status;
}

export function agreementWorkflowTaskActionLabel(task, memberId) {
  const agreement = task.workflow_artifact?.agreement;

  if (agreement && isNextAgreementSigner(agreement, memberId)) {
    return 'Review and sign';
  }

  return 'View agreement';
}
